// dependencies imports ⇒
import React, { useState, useEffect, useRef } from "react";
// assets and scss imports ⇒
import FilterListIcon from "@mui/icons-material/FilterList";
import "./consentListTableHeader.scss";
// project file imports(UI components) ⇒
import FilterMenuList from "../../../../common/Modules/FilterMenuList";
// const file imports(helper methods, etc) ⇒

function ConsentListTableHeader(props) {
  // const declarations ⇒
  const {
    requestStatusOptions,
    grantedStatusOptions,
    createdStatusOptions,
    setRequestStatusOptions,
    setCreatedStatusOptions,
    setGrantedStatusOptions,
    setActivePage,
  } = props;

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isCreatedDropdownOpen, setIsCreatedDropdownOpen] = useState(false);
  const [isGrantedDropdownOpen, setIsGrantedDropdownOpen] = useState(false);

  const requestDropDownRef = useRef(null);
  const createdDropdownRef = useRef(null);
  const grantedDropdownRef = useRef(null);

  // let or var declarations ⇒

  // life cycle methods ⇒

  // API Calls ⇒

  // Helper methods ⇒

  const useClickAwayListener = (ref, callback) => {
    useEffect(() => {
      const handleClickAway = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
          callback();
        }
      };

      document.addEventListener("mousedown", handleClickAway);

      return () => {
        document.removeEventListener("mousedown", handleClickAway);
      };
    }, [ref, callback]);
  };

  // Actions ⇒
  useClickAwayListener(requestDropDownRef, () => setIsDropdownOpen(false));
  useClickAwayListener(createdDropdownRef, () =>
    setIsCreatedDropdownOpen(false)
  );
  useClickAwayListener(grantedDropdownRef, () =>
    setIsGrantedDropdownOpen(false)
  );

  const handleDropdownToggle = (setter) => () => {
    setter((prev) => !prev);
  };

  const chooseFilter = (options, setter, toggle) => (selectedItem) => {
    const updatedOptions = options.map((item) => ({
      ...item,
      selected: item.value === selectedItem.value,
    }));

    setter(updatedOptions);
    toggle(false);
    setActivePage(1);
  };
  // create UI ⇒

  const consentListTableHeaderUI = (
    title,
    options,
    isOpen,
    toggle,
    onChooseFilter,
    dropdownRef
  ) => (
    <div ref={dropdownRef} className="consent-list-table-header-content">
      <div className="consent-list-table-header-title">
        {title}
        <FilterListIcon
          className="filter-button"
          onClick={toggle}
          sx={{ fontSize: "20px" }}
        />
        {isOpen && (
          <FilterMenuList menuItemList={options} toggleItems={onChooseFilter} />
        )}
      </div>
    </div>
  );

  function consentListTableHeader() {
    return (
      <div className="consent-list-table-header-wrapper">
        {consentListTableHeaderUI(
          "REQUEST STATUS",
          requestStatusOptions,
          isDropdownOpen,
          handleDropdownToggle(setIsDropdownOpen),
          chooseFilter(
            requestStatusOptions,
            setRequestStatusOptions,
            setIsDropdownOpen
          ),
          requestDropDownRef
        )}
        {consentListTableHeaderUI(
          "CONSENT CREATED ON",
          createdStatusOptions,
          isCreatedDropdownOpen,
          handleDropdownToggle(setIsCreatedDropdownOpen),
          chooseFilter(
            createdStatusOptions,
            setCreatedStatusOptions,
            setIsCreatedDropdownOpen
          ),
          createdDropdownRef
        )}
        {consentListTableHeaderUI(
          "CONSENT GRANTED ON",
          grantedStatusOptions,
          isGrantedDropdownOpen,
          handleDropdownToggle(setIsGrantedDropdownOpen),
          chooseFilter(
            grantedStatusOptions,
            setGrantedStatusOptions,
            setIsGrantedDropdownOpen
          ),
          grantedDropdownRef
        )}
      </div>
    );
  }

  //

  return <div>{consentListTableHeader()}</div>;
}

export default ConsentListTableHeader;
